import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import { useEffect, useState } from 'react';
import Hamburger from 'hamburger-react'

import { ReactComponent as Logo } from "../assets/hatmedecem-logo.svg";

import Groups3Icon from '@mui/icons-material/Groups3';
import AssistantIcon from '@mui/icons-material/Assistant';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { CButton } from '../components';
import { useWindowDimensions } from './useWindowDimensions';
import MaxWidthWrapper from './MaxWidthWrapper';


export default function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(null);


  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let auth = getAuth()

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User

        setIsAuthenticated(true)
      } else {
        setIsAuthenticated(false)
      }
    }, []);
  }, [])

  const { height, width } = useWindowDimensions();

  const isAuthenticating = ["giris", "kayit"].includes(window.location.toString().split("/").at(-1))

  //alert(isAuthenticating)

  return <Box sx={{ borderBottom: '1px solid #eaeaea', px: 2 }}>
    <MaxWidthWrapper>
      <div style={{
        display: "flex", 
        justifyContent: "space-between", 
        alignItems:"center", 
        padding: "10px 0"
      }}>
        <div style={{ height: "50px", display:"flex" }} onClick={() => {window.location = '/'}}>
          { width > 368 && <div style={{width:"60px", marginRight:"15px"}}><Logo /></div>}
          <h3>Hatmedecem</h3>
        </div>

        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
          {(
            auth.currentUser === undefined && isAuthenticated === null) ? <></> : 
          isAuthenticated === true ? <Tooltip title="Menü">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Hamburger toggled={anchorEl} />
            </IconButton>
          </Tooltip> : !isAuthenticating ?
            <CButton
              style={{
                backgroundColor: "#EDAFB8",
                fontSize: "14px",
                padding: "5px 10px"
              }}
              onClick={() => {
                window.location = '/giris'
              }}
            >Giriş Yap</CButton> : <></>}
        </Box>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          
          <MenuItem onClick={() => {
            handleClose()
            window.location.href = '/iletisim';
          }}>
            <ListItemIcon>
              <AssistantIcon fontSize="small" />
            </ListItemIcon>
            İletişim Formu
          </MenuItem>
          <MenuItem onClick={() => {
            handleClose()
            getAuth().signOut()
          }}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Çıkış Yap
          </MenuItem>
        </Menu>
      </div>
    </MaxWidthWrapper>
  </Box>

}